import React, { useEffect, useState } from "react";
import { useParams, Link, Outlet, useNavigate } from "react-router-dom";
import apiClient from "../../Services/apiClient";

function ServiceApplyPage() {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const [service, setService] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");

    apiClient
      .get(`services/${serviceId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const schema = JSON.parse(res.data.formSchema || "[]");
        setService({ ...res.data, formSchema: schema });

        // Initialize formData
        const initialForm = {};
        schema.forEach((f) => {
          initialForm[f.id] = f.type === "file" ? null : "";
        });
        setFormData(initialForm);
      })
      .catch((err) => console.error(err));
  }, [serviceId]);

  const handleInputChange = (e) => {
    const { name, value, files, type } = e.target;
    setFormData({ ...formData, [name]: type === "file" ? files[0] : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      const payload = new FormData();
      Object.keys(formData).forEach((key) => payload.append(key, formData[key]));

      await apiClient.post(`services/${serviceId}/apply`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Application submitted successfully!");
      setLoading(false);
      navigate("/dashboard"); // redirect after submission
    } catch (err) {
      console.error(err);
      alert("Failed to submit application.");
      setLoading(false);
    }
  };

  if (!service) return <p>Loading...</p>;

  // Split fields into rows of 3 columns (col-md-4)
  const chunkFields = (fields, size) => {
    const chunks = [];
    for (let i = 0; i < fields.length; i += size) {
      chunks.push(fields.slice(i, i + size));
    }
    return chunks;
  };

  const fieldRows = chunkFields(service.formSchema, 3);

  return (
    <div>
      <div className="wrapper">
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">

              {/* PAGE TITLE */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="/dashboard">Dashboard</Link>
                        </li>
                        <li className="breadcrumb-item active">Loan Application</li>
                      </ol>
                    </div>
                    <h4 className="page-title">{service.name}</h4>
                  </div>
                </div>
              </div>

              {/* FORM */}
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <form onSubmit={handleSubmit} encType="multipart/form-data">
                        {fieldRows.map((row, idx) => (
                          <div className="row g-2 mb-3" key={idx}>
                            {row.map((field) => (
                              <div
                                className={`mb-3 col-md-${field.type === "textarea" ? 8 : 4}`}
                                key={field.id}
                              >
                                <label className="form-label">{field.label}</label>
                                {field.type === "textarea" ? (
                                  <textarea
                                    className="form-control"
                                    name={field.id}
                                    value={formData[field.id]}
                                    required={field.required}
                                    placeholder={field.placeholder || ""}
                                    onChange={handleInputChange}
                                    rows={2}
                                  />
                                ) : field.type === "file" ? (
                                  <input
                                    type="file"
                                    className="form-control"
                                    name={field.id}
                                    required={field.required}
                                    onChange={handleInputChange}
                                  />
                                ) : field.type === "select" && field.options?.length > 0 ? (
                                  <select
                                    className="form-control"
                                    name={field.id}
                                    value={formData[field.id]}
                                    required={field.required}
                                    onChange={handleInputChange}
                                  >
                                    <option value="">Select {field.label}</option>
                                    {field.options.map((opt) => (
                                      <option value={opt.value} key={opt.value}>
                                        {opt.label}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <input
                                    type={field.type}
                                    className="form-control"
                                    name={field.id}
                                    value={formData[field.id]}
                                    required={field.required}
                                    placeholder={field.placeholder || ""}
                                    onChange={handleInputChange}
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        ))}

                        <button type="submit" className="btn btn-primary" disabled={loading}>
                          {loading ? "Submitting..." : "Submit Loan Application"}
                        </button>

                      </form>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <Outlet />
    </div>
  );
}

export default ServiceApplyPage;
